import { IonNote, IonActionSheet, IonRippleEffect, IonModal, IonList, IonPopover, useIonRouter, useIonViewWillLeave, IonFooter, IonChip, useIonViewDidEnter, IonInfiniteScrollContent, IonInfiniteScroll, IonText, IonThumbnail, IonBadge, IonImg, IonTextarea, IonProgressBar, IonAlert, IonGrid, IonRow, IonCol, IonCardTitle, IonCardSubtitle, IonCardHeader, IonCardContent, IonAvatar, IonToast, useIonViewWillEnter, IonIcon, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useRef, Component, useState, useEffect }  from 'react';
import { RouteComponentProps } from "react-router-dom";
import { chatboxEllipsesOutline, trashBinOutline, lockOpenOutline, lockClosedOutline, createOutline, copyOutline, close, arrowRedoOutline, peopleOutline, imagesOutline, banOutline, trashOutline, listOutline, ellipsisVertical, walletOutline, imageOutline, closeOutline, personAdd, addOutline, sendOutline } from "ionicons/icons";
import { Keyboard } from '@capacitor/keyboard';
import { Camera, CameraResultType } from '@capacitor/camera';
import { Clipboard } from '@capacitor/clipboard';
import { Virtuoso, VirtuosoHandle } from 'react-virtuoso';

import '../pages/Main.css';
import '../pages/ChatMsg.css';

import { showTab, hideTab } from "../components/Tabs";
import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer, { handleRouteError, RegisterAppServices } from "../components/NServer";
import Vault from '../components/Vault';

import { MsgData, MsgDataGroup, MsgUser } from "../data/message";
import ChatMsgGroup from "../components/ChatMsgGroup";
import { showAlert } from '../components/Alert';
import GifContent, { LoadGifs, GifData } from "../components/GifContent";
import LikeErrComp from "../components/LikeErrComp";
import { ReadyAds, ShowAds } from "../components/Admob";

const total = 30;
var maxIndex = -1;
var minIndex = Number.MAX_VALUE;
var rawMsgList : MsgData[] = [];
var refreshTimer : any;
var chat_type : string = "";
var block_user : number = -1;
var block_type : string = "";
var scroll_y = 0;
var typed_msg : string = "";


interface ChatCompProp {
    id : any,
    timer : any,
    type : string,
    bk : string,
    setServer : any,
    setRepliedMsg : any
}

const ChatComp : React.FC<ChatCompProp> = ({ id, timer, type, bk, setServer, setRepliedMsg }) => {
    
    const contentRef = useRef<VirtuosoHandle | null>(null);
    const [formatMsgList, setFormatList] = useState<MsgDataGroup[]>([]);
    const [memberList, setMemberList] = useState<MsgUser[]>([]);
    const [offline, setOffline] = useState(false);
    const [color, setColor] = useState("");
    const [seenBy, setSeenBy] = useState("");
    const [chatType, setChatType] = useState("");
    const [noMoreLoadData, setNoMoreLoadData] = useState(false);
    const [adminMode, setAdminMode] = useState(false);
    const [curMsg, setCurMsg] = useState<any>({});
    const [ownedMsg, setOwnedMsg] = useState(false);
    const [menu, openMenu] = useState(false);
    const [adReady, setAdReady] = useState(false);
    const [likeError, showLikeError] = useState(false);
    const [blockAsk, setBlockAsk] = useState(false);

    //	Initializing our router
	const router = useIonRouter();

    // need to refresh
    useEffect(() => {
        // init
        rawMsgList = [];
        maxIndex = -1;
        minIndex = Number.MAX_VALUE;

        getData(1);
    },[id]);

    // need to refresh
    useEffect(() => {
        getData(1);
    },[timer]);

    // load more data
    const loadMoreData = async () => {
        
        await getData(-1);
    }  

    const getData = async (dir : number, scroll : boolean = false) => {
        let v = new Vault();
        await v.read();

        var index = maxIndex;
        if (dir < 0)
            index = minIndex;

        let typing = typed_msg != "";
        
        const state = {
            id: v.account.id,
            pass: v.account.key,
            other : id,
            type : type,
            typing: typing ? 1 : 0,
            s : index,
            e : total,
            d : dir
        }

        var server = new NServer();
        await server.getList("message", state);

        if (!server.success && server.message != "")
        {
            setOffline(true);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            // update the UI
            setMemberList(server.data.members);
            setChatType(server.data.chat_type);
            
            setColor(server.data.color);
            setSeenBy(server.data.seenby);
            setAdminMode(server.data.admin == 13);

            setServer(server);

            chat_type = server.data.chat_type;

            if (server.data.msg.length > 0)
            {
                var msg_list : MsgData[];
                if (dir < 0)
		            msg_list = rawMsgList.concat(server.data.msg);
                else
                    msg_list = server.data.msg.concat(rawMsgList);
                
                // filter duplicates    
                msg_list = FilterUniqueMsg(msg_list);

                var moreData = false;
                if (dir > 0)
                    moreData = true;

                rawMsgList = msg_list;
                buildMsgList(msg_list);

                if (dir > 0 && moreData && scroll)
                {
                    setTimeout(()=> { scrollToBottom() }, 500);
                }
            }
            else
            {
                // if we reach end of data
                if (dir < 0)
                    setNoMoreLoadData(true);
            }

            setOffline(false);
        }

        if (rawMsgList.length < total)
            setNoMoreLoadData(true);
	}

    // build a formatted msg list
    const buildMsgList = async (mlist : MsgData[]) => {
        
        let v = new Vault();
        await v.read();

        const ownerID = v.account.id;

        let formatList : MsgDataGroup[] = [];

        // loop through the array
        var prev : MsgData;
        var next : MsgData;
        var cur : MsgData;
        var curGroup : MsgDataGroup = {} as MsgDataGroup;
        curGroup.sender = -1;
        var msgID : number = 0;
        var showName : boolean = false;

        for (var i = 0; i < mlist.length; i++)
        {
            cur = mlist[i];

            var owner : boolean = false;
            if (ownerID == cur.sender)
                owner = true;
            var format : string = "";
            showName = false;

            // save min and max
            if (maxIndex < cur.id)
                maxIndex = cur.id;
            if (minIndex > cur.id)
                minIndex = cur.id;

            let msg_typef = "msg msg-text";
            if (cur.type == "post")
                msg_typef = "msg msg-post-share";
            if (cur.type == "img")
                msg_typef = "msg-image";

            if (i > 0)
            {
                prev = mlist[i-1];
                if (prev.sender == cur.sender)
                {
                    format = owner ? "m-bottom-right" : "m-bottom-left";
                }
            }

            if (i+1 < mlist.length)
            {
                next = mlist[i+1];
                if (next.sender == cur.sender)
                {
                    if (format != "")
                        format = owner ? "m-right" : "m-left";
                    else
                        format = owner ? "m-top-right" : "m-top-left";
                }

                // show name on last message
                if (next.sender != cur.sender)
                {
                    if (!owner && chat_type == "live")
                        showName = true;
                }
            }

            // for last message
            if (i+1 == mlist.length)
            {
                if (!owner && chat_type == "live")
                    showName = true;
            }

            // add new chat group if not current sender
            if (curGroup.sender != cur.sender || id == 8)
            {
                
                // add a new message
                curGroup = { 
                             id: msgID++, 
                             messages: [], 
                             sender: cur.sender, 
                             name : cur.name,
	                         avatar : cur.avatar,
	                         owned : owner,
                             last_sent : cur.send_time
                            };
                formatList.push(curGroup);
            }

            // add message
            curGroup.messages.push({
                id : cur.id,
                thread : cur.thread,
                sender : cur.sender,
	            name : cur.name,
	            type : cur.type,
	            avatar : cur.avatar,
	            msg : cur.msg,
	            send_time : cur.send_time,
	            dtime : cur.dtime,
	            format : msg_typef + " " + format,
                showName: showName,
                ref_name : cur.ref_name,
                ref_msg : cur.ref_msg,
                emo : cur.emo,
                extra : cur.extra,
                followed : cur.followed
            });

            curGroup.last_sent = cur.send_time;
        }

        formatList.map( (m) => m.messages.reverse() );
        formatList.reverse();

        setFormatList(formatList);
    }

    // filter unique msg
    const FilterUniqueMsg = (arr : any) : any => {
        let filterList : MsgData[] = [];
        if (arr == null)
            return filterList;

        for (var i = 0; i < arr.length; i++)
        {
            // filter the list
            var same = false;
            for (var j = 0; j < filterList.length; j++)
            {
                if (filterList[j].id == arr[i].id)
                {
                    same = true;
                    break;
                }
            }

            if (!same)
                filterList.push(arr[i]);
        }
        return filterList;
    }

    // scroll to bottom
    const scrollToBottom = () => {
    }

    // click on a message
    const onClickMsg = async (m : MsgData) => {
        // upload image
        let v = new Vault();
        await v.read();

        let owned = false;
        if (v.account.id == m.sender)
            owned = true;
        if (adminMode)
            owned = true;

        setCurMsg(m);
        setOwnedMsg(owned);
        openMenu(true);
    }

    // emoticon was reacted
    const onEmoticon = async (msg : MsgData, index : number) => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            mid : msg.id,
            type: index
        }

		var server = new NServer();
        await server.sendForm("msg_emo", state);

        if (!server.success && server.message != "")
        {
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        
        // refresh msg
        rawMsgList = [];
        maxIndex = -1;
        minIndex = Number.MAX_VALUE;

        getData(1, false);
    }

    // send a like
    const sendLikes = async (msgid : number, likes : number) => {
        // send like to server
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: msgid,
            likes: likes,
            ano: 0
        }

		var server = new NServer();
        await server.sendForm("nc_msg_like", state);

        if (server.data.nolike == 1)
        {
            let ready = await ReadyAds();
            setAdReady(ready);
            showLikeError(true);
            return;
        }

        if (!server.success && server.message != "")
        {
            showAlert(server.message);
        }
        else
        {
            if (server.data.has_token == "no")
            {
                showAlert(GetStr(LANGUAGE.TXT_NO_NTOKEN_LIKE));
            }

            // refresh msg
            rawMsgList = [];
            maxIndex = -1;
            minIndex = Number.MAX_VALUE;

            getData(1, false);
        }
    }

    // reply to message
    const replyMsg = () => {
        setRepliedMsg(curMsg);
    }

    // copy current text
    const copyText = async () => {
        openMenu(false);

        await Clipboard.write({
            string: curMsg.msg
        });
    }

    // delete the message
    const deleteCurMsg = async () => {
        curMsg.type = "del";

        // find the message
        for (let i = 0; i < rawMsgList.length; i++)
        {
            if (rawMsgList[i].id == curMsg.id)
                rawMsgList[i].type = "del";
        }
        
        // refresh local
        buildMsgList(rawMsgList);

        // actually delete the message
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            msg_id : curMsg.id
        }

		var server = new NServer();
        await server.sendForm("del_one_msg", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
    }

    // block the user
    const blockMsgUser = () => {
        block_user = curMsg.sender;
        block_type = "user";
        setBlockAsk(true);
    }

    // block the user
    const blockUser = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: block_user,
            type : block_type
        }

		var server = new NServer();
        await server.sendForm("block", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            router.push("/messages", "back", "pop");
            window.location.reload();
        }
    }

    // watch an Ads
    const watchAds = () => {
        setAdReady(false);
        showLikeError(false);
        
        // show the ads
        ShowAds( () => {
            
        });
    }

    return (
        <div className="chat-wrapper">
            {
                /* chat background */
                bk != "" ?
            <div id="chat-bk" className="chat-bk-img" style={{ backgroundImage: "url('" + bk + "')" }} />
                :
            <div/>
            }
            { /* main chat component */ }
            <IonGrid className="chat-container ion-no-padding full-screen">
                <IonRow className="full-screen">
                    <IonCol>
                        {                
                            formatMsgList.length > 0 ?
                        <Virtuoso id="chat-view" className="ion-content-scroll-host"
                            ref={contentRef}
                            data={formatMsgList}
                            initialTopMostItemIndex={9999}
                            totalCount={formatMsgList.length}
                            followOutput="auto"
                            components={{
                                Header: () => {
                                    return (
                                        <div className="ion-text-center">
                                            <IonChip onClick={ loadMoreData }>{ GetStr(LANGUAGE.TXT_CHAT_LOADMORE) }</IonChip>
                                        </div>
                                    )
                                },
                                Footer: () => {
                                    return (
                                        <div className="chat-footer">{ seenBy }</div>
                                    )
                                },
                            }}
                            itemContent={(index, m) => 
                                <ChatMsgGroup key={index} group={m} action={ onClickMsg } emo={ onEmoticon } like={ sendLikes } ctype="" />
                            }
                        >
                        </Virtuoso>
                            :
                        (id == 1 ?
                        <IonGrid className="ion-no-padding">
                            <IonRow>
                                <IonCol>
                                </IonCol>
                                <IonCol className="ion-text-center" size-md="8" size-lg="6" size-xl="4" size="10">
                                    <div><IonText><h4>{ GetStr(LANGUAGE.TXT_INFO_HELP_CAP) }</h4></IonText></div>
                                    <div><IonImg className="info-pic" src="/assets/img/help_pic.png" /></div>
                                    <div><IonText>{ GetStr(LANGUAGE.TXT_INFO_HELP_DESC) }</IonText></div>
                                </IonCol>
                                <IonCol>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                            :
                        <div/>
                    )
                    }
                    </IonCol>
                </IonRow>
            </IonGrid>

            { /* menu */ }
            <IonActionSheet
                isOpen={menu}
                onDidDismiss={() => openMenu(false)}
                buttons={
                    ownedMsg ?    
                    [
                    {
                        text: GetStr(LANGUAGE.TXT_MSG_REPLY_CUR),
                        icon: arrowRedoOutline,
                        handler: replyMsg
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_COPY_TEXT),
                        icon: copyOutline,
                        handler: copyText
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_MSG_DEL_CUR),
                        icon: trashOutline,
                        handler: deleteCurMsg
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_CANCEL),
                        icon: close,
                        role: 'cancel',
                        handler: () => { openMenu(false) }
                    } 
                    ]
                    :
                    [
                    {
                        text: GetStr(LANGUAGE.TXT_MSG_REPLY_CUR),
                        icon: arrowRedoOutline,
                        handler: replyMsg
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_COPY_TEXT),
                        icon: copyOutline,
                        handler: copyText
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_BLOCK_USER),
                        icon: banOutline,
                        handler: blockMsgUser
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_CANCEL),
                        icon: close,
                        role: 'cancel',
                        handler: () => { openMenu(false) }
                    } 
                    ]
                }
                >
            </IonActionSheet>

            { /* like error dialogbox */ }
            <LikeErrComp  isOpen={ likeError } onDidDismiss={ () => showLikeError(false) } adReady={ adReady } watchAds={ watchAds }  />

            <IonAlert
                isOpen={blockAsk}
                onDidDismiss={() => setBlockAsk(false)}
                header={GetStr(LANGUAGE.TXT_BLOCK_CHAT_TITLE)}
                message={GetStr(LANGUAGE.TXT_BLOCK_CHAT_DESC)}
                buttons={[
                    {
                        text: GetStr(LANGUAGE.TXT_CANCEL),
                        role: 'cancel',
                        cssClass: 'secondary',
                        id: 'cancel-button'
                    },
                    {
                        text: GetStr(LANGUAGE.TXT_OK),
                        id: 'confirm-button',
                        handler: () => {
                            blockUser();
                        }
                    }
                ]}
            />
        </div>
    );
};
  
export default ChatComp;